const IMAGE_ROOT = "/image/lp/animefurusato";
export const imagePath = (path: string): string => {
  return IMAGE_ROOT + path;
};
